const REQUEST_ORDERS_STATS = "REQUEST_ORDERS_STATS";
const RECEIVE_ORDERS_STATS = "RECEIVE_ORDERS_STATS";

export default {
    REQUEST_ORDERS_STATS, 
    RECEIVE_ORDERS_STATS, 
}